module.exports = __webpack_public_path__ + "static/media/proj6_img3.f2f756f2.jpg";